import { PageViews, CustomEvent } from '@piwikpro/react-piwik-pro';
import { isProdEnv } from '../helpers';

const usePiwikPro = () => {
    const trackPageView = (pageName: string) => {
        if (isProdEnv()) {
            PageViews.trackPageView(pageName);
        }
    };

    const trackEvent = (category: string, action: string, name?: string) => {
        if (isProdEnv()) {
            CustomEvent.trackEvent(category, action, name);
        }
    };

    return { trackPageView, trackEvent };
};

export default usePiwikPro;
